import { ShieldCheck } from "lucide-react";
import { FormProvider, UseFormReturn } from "react-hook-form";

import { FormControl, FormField, FormItem, FormMessage } from "@/components";
import {
  Button,
  InputOTP,
  InputOTPGroup,
  InputOTPSeparator,
  InputOTPSlot,
} from "@/components";
import { useI18n } from "@/context";

import { ITwoFactorFormValues } from "../../login.types";
export interface ITwoFactorProps {
  twoFactorForm: UseFormReturn<ITwoFactorFormValues>;
  onSubmit: (data: ITwoFactorFormValues) => void;
  onCancel: () => void;
}

export const TwoFactor: React.FC<ITwoFactorProps> = ({
  twoFactorForm,
  onSubmit,
  onCancel,
}) => {
  const { t } = useI18n();
  const methodLabel =
    twoFactorForm.getValues("method") === "EMAIL"
      ? t("auth.twoFactorDescriptionEmail")
      : t("auth.twoFactorDescriptionApp");

  return (
    <div className="max-w-sm mx-auto space-y-4">
      <div className="flex flex-col items-center space-y-4">
        <ShieldCheck className="w-16 h-16" />
        <h1 className="text-2xl font-semibold">{t("auth.twoFactor")}</h1>
        <p className="text-muted-foreground text-sm">{methodLabel}</p>
      </div>
      <FormProvider {...twoFactorForm}>
        <form
          onSubmit={twoFactorForm.handleSubmit(onSubmit)}
          className="flex flex-col space-y-4 w-full justify-center items-center"
        >
          <FormField
            control={twoFactorForm.control}
            name="passcode"
            render={({ field }) => (
              <div className="flex items-center gap-2">
                <FormItem>
                  <FormControl>
                    <InputOTP
                      autoFocus
                      maxLength={6}
                      value={field.value}
                      onChange={(value) => {
                        field.onChange(value);
                        if (value.length === 6) {
                          twoFactorForm.handleSubmit(onSubmit)();
                        }
                      }}
                      onPaste={(e) => {
                        e.preventDefault();
                        const pastedData = e.clipboardData
                          .getData("text")
                          .replace(/\D/g, "");
                        field.onChange(pastedData);
                        if (pastedData.length === 6) {
                          twoFactorForm.handleSubmit(onSubmit)();
                        }
                      }}
                    >
                      <InputOTPGroup className="gap-2">
                        <InputOTPSlot
                          index={0}
                          className="w-12 h-12 border-2"
                        />
                        <InputOTPSlot
                          index={1}
                          className="w-12 h-12 border-2"
                        />
                        <InputOTPSlot
                          index={2}
                          className="w-12 h-12 border-2"
                        />
                        <InputOTPSeparator className="text-muted-foreground" />
                        <InputOTPSlot
                          index={3}
                          className="w-12 h-12 border-2"
                        />
                        <InputOTPSlot
                          index={4}
                          className="w-12 h-12 border-2 "
                        />
                        <InputOTPSlot
                          index={5}
                          className="w-12 h-12 border-2 "
                        />
                      </InputOTPGroup>
                    </InputOTP>
                  </FormControl>
                  <FormMessage />
                </FormItem>
              </div>
            )}
          />

          <Button type="submit" className="w-full">
            {t("generic.confirm")}
          </Button>
          <Button
            type="button"
            variant="outline"
            className="w-full"
            onClick={onCancel}
          >
            {t("generic.cancel")}
          </Button>
        </form>
      </FormProvider>
    </div>
  );
};
